/* tslint:disable:react-no-dangerous-html */
import * as classNames from 'classnames'
import random from 'lodash-es/random'
import * as React from 'react'

import { IBannerApiData } from '../../../common/actions/marketing/banner'
import { reportHeaderBannerClick } from '../../../common/analytics/bannerAnalytics'

interface IProps {
  banners: IBannerApiData[]
}

interface IState {
  bannerConfig: IBannerApiData | null
  hideBanner: boolean
  hasBindedDismissEvent: boolean
  hasBindedClickEvent: boolean
}

class HeadBanner extends React.Component<IProps, IState> {
  private $dom: HTMLDivElement | null

  constructor(props: IProps) {
    super(props)

    this.$dom = null

    // we should not rendering any thing from server side for two reasons:
    // 1. content will be cached through CDN, and we don't want it to be cached
    // 2. we will get react invalid checksum warning because server and client
    // render differnt content
    this.state = {
      bannerConfig: null,
      hasBindedClickEvent: false,
      hasBindedDismissEvent: false,
      hideBanner: false
    }
  }

  public componentDidMount() {
    const { banners } = this.props
    const bannerId = banners && banners[0] ? banners[0].id : null

    if (bannerId) {
      const bannerCacheKey = `banner_${bannerId}_cache`
      const localStorageSupported = !!window.localStorage
      // should not show the banner if it's already dismissed
      const hasDimissed = localStorageSupported
        ? window.localStorage.getItem(bannerCacheKey) === 'hidden'
        : false
      if (localStorageSupported && !hasDimissed) {
        // if it's not dismissed
        // we load random banner config after page is loaded
        const bannerIndex = random(banners.length - 1)
        const bannerConfig = banners[bannerIndex]

        this.setState({
          bannerConfig
        })
      }
    }
  }

  public componentDidUpdate() {
    const {
      bannerConfig,
      hasBindedDismissEvent,
      hasBindedClickEvent
    } = this.state
    const dismissButton = this.querySelector('.js-banner__dismiss')
    const bannerLinkButton = this.querySelector('.js-banner__link')
    // only bind the dismiss event when the banner is loaded
    if (bannerConfig) {
      if (dismissButton && !hasBindedDismissEvent) {
        this.bindDismissEvent(bannerConfig)
      }
      if (bannerLinkButton && !hasBindedClickEvent) {
        this.bindBannerClickEvent(bannerConfig)
      }
    }
  }

  public render() {
    const { bannerConfig, hideBanner } = this.state

    if (!bannerConfig) {
      return null
    }

    const bannerContainerClassName = classNames('banner-root', {
      'banner-slide-up': hideBanner
    })

    return (
      <div
        className={bannerContainerClassName}
        ref={$dom => {
          this.$dom = $dom
        }}
      >
        <style>{bannerConfig.css}</style>
        <div
          className="banner-container"
          dangerouslySetInnerHTML={{ __html: bannerConfig.html }}
        />
      </div>
    )
  }

  private bindDismissEvent(bannerConfig: IBannerApiData) {
    if (this.$dom) {
      const dismissButtons = this.$dom.querySelectorAll('.js-banner__dismiss')
      // this should always align with the key set by marketplace
      const bannerCacheKey = `banner_${bannerConfig.id}_cache`

      if (dismissButtons) {
        this.setState({
          hasBindedDismissEvent: true
        })
        Array.from(dismissButtons).forEach(dismissButton => {
          dismissButton.addEventListener('click', event => {
            event.preventDefault()
            const localStorageSupported = !!window.localStorage
            if (localStorageSupported) {
              window.localStorage.setItem(bannerCacheKey, 'hidden')
            }
            this.setState({
              hideBanner: true
            })
          })
        })
      }
    }
  }

  private querySelector(selector: string) {
    if (this.$dom) {
      return this.$dom.querySelector(selector)
    }
    return null
  }

  private bindBannerClickEvent(bannerConfig: IBannerApiData) {
    if (this.$dom) {
      const bannerLinkButtons = this.$dom.querySelectorAll('.js-banner__link')
      const bannerId = bannerConfig.id

      if (bannerLinkButtons) {
        this.setState({
          hasBindedClickEvent: true
        })
        Array.from(bannerLinkButtons).forEach(bannerLinkButton => {
          bannerLinkButton.addEventListener('click', event => {
            const payload = {
              id: bannerId,
              name: bannerId
            }
            reportHeaderBannerClick(payload)
          })
        })
      }
    }
  }
}

export default HeadBanner
